import {PeriodTimeForms, PeriodMapping, PeriodType} from "../types";

const periodMappings: PeriodMapping = {
  yearly: {
    adjective: "annual",
    adverb: "yearly",
    singular: "year",
  },
  monthly: {
    adjective: "monthly",
    adverb: "monthly",
    singular: "month",
  },
  weekly: {
    adjective: "weekly",
    adverb: "weekly",
    singular: "week",
  },
  daily: {
    adjective: "daily",
    adverb: "daily",
    singular: "day",
  },
};

export const getDateWithDaysOffset = (date: Date, days: number): Date => {
  const newDate = new Date(date)
  newDate.setDate(newDate.getDate() + days);

  return newDate;
};

export const getMonthDayYearDateString = (date: Date): string => {
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const getFormattedDueDate = (date: Date, days: number) => {
  return getMonthDayYearDateString(getDateWithDaysOffset(date, days))
}

export const getPeriodString = (
  period: PeriodType
): PeriodTimeForms | undefined => {
  return periodMappings?.[period] || undefined;
};
